import DownloadAssetRequestModelBase from '../_generated/modelBases/download-asset-request-model-base';

export default class DownloadAssetRequestModel extends DownloadAssetRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
